import { modeTypes } from '@/constants/modes';

export const isDevelopment = import.meta.env.MODE === modeTypes.development;
export const isProduction = import.meta.env.MODE === modeTypes.production;
export const isMock = import.meta.env.MODE === modeTypes.mock;

export const modeType = isDevelopment
  ? modeTypes.development
  : isMock
    ? modeTypes.mock
    : modeTypes.production;
